<div *ngIf="alertText.length > 0">
    <tc-inline-alert [type]="inlineAlertTypes.warning" [text]="alertText"></tc-inline-alert>
    <br>
</div>